export default __webpack_public_path__ + "static/media/college-banner.b8ea6547.svg";